<template>
  <div class="subscription-tariff-card__list-item">
    <SubscriptionTariffDescriptionItem
      v-if="mdOrDown"
      :item="descriptionItem"
      class="mb-2"
    />
    <div class="subscription-tariff-card__list-item-value">{{ value }}</div>
  </div>
</template>

<script>
import windowSizeMixin from '../../mixins/windowSizeMixin';

export default {
  name: 'SubscriptionTariffCardItem',
  components: {
    SubscriptionTariffDescriptionItem: () => import('./SubscriptionTariffDescriptionItem'),
  },
  mixins: [windowSizeMixin],
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    descriptionItem: {
      type: Object,
      required: true,
    },
  },
};
</script>
